module.exports = __webpack_public_path__ + "img/lottery_Rule.34b170bf.png";